import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import { SafeArea } from '@capacitor-community/safe-area'

// capacitor.config.ts only wires this plugin's static config up for iOS
// (deleted for ANDROID builds), so Android never got the black status/nav
// bar treatment. Enabling it here at runtime covers both platforms from one
// shared place instead of duplicating it per app (employee vs carrier).
const SYSTEM_BAR_CONFIG = {
  customColorsForSystemBars: true,
  statusBarColor: '#000000',
  statusBarContent: 'light' as const,
  navigationBarColor: '#000000',
  navigationBarContent: 'light' as const,
  offset: 0,
}

const SafeAreaController = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    SafeArea.enable({ config: SYSTEM_BAR_CONFIG })
  }, [])

  return null
}

export default SafeAreaController
